import React from 'react';
import { Badge } from '../Badge';
import { CtaButton } from '../CtaButton';
import { IMAGES } from '../../lib/content';
export function Founder() {
  return <section className="w-full bg-[#A9DFE9]/20 py-20 lg:py-28" data-id="element-36" data-mp="dg2ublqnsv1z">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-[0.8fr_1fr]" data-id="element-37" data-mp="8foirtpun2z7">
        <div className="order-2 lg:order-1" data-id="element-38" data-mp="3hdavoj472jm">
          <article className="overflow-hidden rounded-[2rem] bg-white shadow-soft ring-1 ring-white/60" data-id="element-39" data-mp="113ayg0ccpy2f">
            <div className="bg-white" data-id="element-40" data-mp="w4ptjnm5mq7n">
              <img src={IMAGES.founder} alt="Dr. Andreina Jativa, Founder and Lead Dentist at Pler Smile" className="h-full w-full object-cover" loading="lazy" data-id="element-41" data-mp="w5sp48uf9gtw" />
            </div>
            <div className="border-t border-[#A9DFE9]/70 px-6 py-6" data-id="element-42" data-mp="mfg126nef5j0">
              <h3 className="text-lg font-bold text-[#1A1A2E]" data-id="element-43" data-mp="1jtsbkwkpal2o">Dr. Andreina Jativa</h3>
              <p className="mt-1 text-sm font-semibold text-[#1F6E7B]" data-id="element-44" data-mp="1jvv8m0k9tegw">Founder &amp; Lead Dentist at Pler Smile</p>
              <p className="mt-3 text-sm leading-relaxed text-[#1A1A2E]/80" data-id="element-45" data-mp="3lvspcm89ygzr">
                DMD from Nova Southeastern University and Master&apos;s in Biological Sciences from Florida International University, she is a member of the American Dental Association and one of South Florida&apos;s leading cosmetic dentists. Certified in Advanced Aesthetic Full Mouth Rehabilitation and Invisalign, she provides bilingual care (English/Spanish) and is a recurring expert guest on Telemundo&apos;s Hoy Día.
              </p>
              <p className="mt-4 border-l-2 border-[#1F6E7B] pl-4 text-sm font-semibold italic leading-relaxed text-[#1F6E7B]" data-id="element-46" data-mp="376whap67x3z5">
                &ldquo;Clinical precision with artistic vision: every smile is designed as a one of a kind piece.&rdquo;
              </p>
            </div>
          </article>
        </div>

        <div className="order-1 lg:order-2" data-id="element-47" data-mp="rgtietcq9ciy">
          <Badge variant="aqua" size="sm" className="landing-badge mb-4 uppercase tracking-wide" data-id="element-48" data-mp="wel8rixq4ql1">Behind the Protocol</Badge>
          <h2 className="text-3xl font-bold leading-tight text-[#1A1A2E] md:text-4xl" data-id="element-49" data-mp="u0g39gzyg8jw">
            &ldquo;My patients did not come looking for teeth. They came looking for the unfiltered photo.&rdquo;
          </h2>

          <div className="mt-6 space-y-5 text-lg leading-relaxed text-[#1A1A2E]/85" data-id="element-50" data-mp="l0b6s1wauuki">
            <p data-id="element-51" data-mp="g0ykpjd95riz">
              For years I watched people accept &ldquo;good enough.&rdquo; Everything changed when a patient cried,
              not from pain, but because she recognized herself for the first time in a decade. That day I
              decided Pler Smile would compete on premium esthetics, never on being the cheapest.
            </p>
            <p data-id="element-52" data-mp="13w18do0bloxv">
              One patient flew in from three states away. She had already visited two other clinics and
              left with generic catalog smiles she could not picture on her own face. She chose Pler Smile
              for one reason. She could see a predictable result, designed to her anatomy, before she
              committed to treatment.
            </p>
            <p data-id="element-53" data-mp="1z0edp1pl75ha">
              What Pler Smile Dadeland delivers isn&apos;t a set of teeth. It&apos;s the moment you stop
              rehearsing your smile in the mirror before walking into a room. That shift shows in your
              family photos, your social gatherings, and the way you sit at a dinner table. It is the entire
              reason the protocol exists.
            </p>
          </div>

          <p className="mt-8 border-l-2 border-[#1F6E7B] pl-6 text-xl font-bold text-[#1F6E7B]" data-id="element-54" data-mp="2hxfjupuvnbmt">
            “Pler Smile Dadeland offers the most carefully crafted smile.”
          </p>
          <p className="mt-5 text-sm italic leading-relaxed text-[#1A1A2E]/75" data-id="element-55" data-mp="2ro0qn0kpfmgt">
            If that is the kind of result you would fly for, here is exactly what the $20,000 includes, line by line.
          </p>
          <div className="mt-8" data-id="element-56" data-mp="31nj6p5xhuo3l"><CtaButton label="Reserve My Free Consultation" data-id="element-57" data-mp="31jvfidfiuds1" /></div>
        </div>
      </div>
    </section>;
}